import axios from 'axios';
import { getOrCreateGuestId } from '../../utils/guestUtils';

const apiService = axios.create({
  baseURL: 'https://japanichiba.duckdns.org/api/v1', 
  headers: {
    'Content-Type': 'application/json',
  },
});

// 1. BỘ CHẶN REQUEST (GỬI ĐI): Tự động đính kèm Token hoặc X-Guest-Id
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); 
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      const guestId = getOrCreateGuestId();
      config.headers['X-Guest-Id'] = guestId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 2. BỘ CHẶN RESPONSE (NHẬN VỀ): Bắt lỗi 401 từ Server trả về để Logout
apiService.interceptors.response.use(
  (response) => {
    // Nếu API chạy thành công (status 2xx), trả về dữ liệu bình thường
    return response;
  },
  (error) => {
    // Sửa lại: Kiểm tra lỗi trả về từ Server thông qua error.response
    if (error.response && error.response.status === 401) {
      
      // 1. Xóa token và thông tin user cũ
      localStorage.removeItem('token');

      localStorage.removeItem('user');

      // Đá về trang login ngay lập tức
      window.location.href = '/';

      localStorage.removeItem('user'); 
      
      // 2. Thông báo cho người dùng
      alert('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại!');
      
      // 3. Đá người dùng ra trang đăng nhập và làm mới trạng thái ứng dụng
      window.location.href = '/'; 

    }
    
    return Promise.reject(error);
  }
);

export default apiService;